





















import { Box, Flex, AltInputLabel } from '../../atoms'
import { Vue, Component, Prop } from 'vue-property-decorator'

@Component({
  components: {
    Box,
    Flex,
    AltInputLabel
  }
})
export default class RiskProfileBox extends Vue {
  @Prop({ required: false, type: String }) readonly riskProfile!: string
}
